import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import Swal from 'sweetalert2'
import { TranslateService } from "@ngx-translate/core";
import { ErrorService } from "../../../control-core/services/error.service";
import { CONTROL_APP_CONST } from "../../config/control-app.constant";
import { IPeticion, IPeticionComentario } from "../../models/whr/peticion.model";
import {
  ISimpleTableConfig,
  SimpleTableConfig
} from "../../../control-core/shared/simple-table/simple-table.component";
import { notify, SUCCESS_NOTIFY } from "../../../control-core/util/notify.util";
import { animation, BOUNCEIN_ANIMATION } from "../../../control-core/util/animation.util";
import { initWaitMe, IWaitMeOption, stopWaitMe, WaitMeOptionModel } from "../../../control-core/util/waitme.util";

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-peticion',
  templateUrl: './peticion.component.html'
})
export class PeticionComponent implements OnInit {

  configTablaPeticiones = new SimpleTableConfig();
  mensajeEstadoPeticion = {finalizado: '', abierto: ''};
  detallePeticion = {
    nrowhr: '', created_at: '', estado: '', descripcion: '', id: '', finalizado: false,
    comentarios: []
  };
  detalleNewComentario = {hasError: false, errorText: "", comentario: ''};
  enviandomensaje: boolean = false;

  numRowsDesc: number = 4;

  private _idDetallPeticionModal = '#detallPeticionModal';
  private readonly _YES_LABEL = this._translate.instant('YES_LABEL');
  private readonly _NO_LABEL = this._translate.instant('NO_LABEL');

  constructor(private _http: HttpClient,
              private _translate: TranslateService,
              private _errorService: ErrorService) {
  }

  ngOnInit() {
    this.mensajeEstadoPeticion.finalizado = this._translate.instant('FINALIZADO_LABEL');
    this.mensajeEstadoPeticion.abierto = this._translate.instant('ABIERTO_LABEL');

    this.configTablaPeticiones.columns = [
      {label: '#', name: 'id_ptc'},
      {label: 'DATE_LABEL', name: 'created_at'},
      {label: 'DATE_RESP_LABEL', name: 'fechaestimada'},
      {label: 'TIPO_LABEL', name: 'tipo_nombre'},
      {
        label: 'ESTADO_LABEL', name: 'finalizado', options: {
        render: (data) => {
          if (data) {
            return '<span class="label label-success">' + this.mensajeEstadoPeticion.finalizado + '</span>';
          } else {
            return '<span class="label label-danger">' + this.mensajeEstadoPeticion.abierto + '</span>';
          }
        }
      }
      },
    ];

    this.configTablaPeticiones.optionColumns = [{
      label: 'DETALLE_LABEL', action: (row) => {
        $(this._idDetallPeticionModal).modal('show');

        this.detallePeticion.id = row.id_ptc;
        this.detallePeticion.nrowhr = row.nrowhr;
        this.detallePeticion.created_at = row.created_at;
        this.detallePeticion.descripcion = row.observacion;
        this.detallePeticion.finalizado = row.finalizado;
        this.detallePeticion.estado = row.finalizado ? this.mensajeEstadoPeticion.finalizado :
            this.mensajeEstadoPeticion.abierto;

        this.detallePeticion.comentarios = row.comentarios;

      }
    },/* {
      label: 'ANULAR_LABEL', action: (row) => {

        let msgConf = '<b>' + this._translate.instant('CONFIRM_ANUL_PETICION_LABEL') + '</b>';
        Swal({
          title: '',
          html: `<span class="font-15">${msgConf}</span>`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this._YES_LABEL,
          cancelButtonText: this._NO_LABEL
        }).then((result) => {
          if (result.value) {
            this._http.post<any>(`${CONTROL_APP_CONST.API_URL}registroPeticion/anular/${row.id_ptc}`, {})
                .subscribe(
                    (response) => {

                      this.consulta();

                      notify(this._translate.instant(response), SUCCESS_NOTIFY);
                    }, (error) => {
                      this._errorService.manejaError(error);
                    }
                )
          }
        });
      }, hidden: (row) => {
        return row.finalizado
      }
    }*/];

    this.consulta()
  }

  private _formatearComentario(comentario: IPeticionComentario): IPeticionComentario {
    comentario['color'] = comentario.idbox ? 'bg-green' : 'bg-orange';
    comentario['autor'] = comentario.idbox ? comentario.cliente : comentario.empleado;
    comentario['classes'] = comentario.idbox ? 'pull-right' : '';
    return comentario;
  }

  consulta() {

    this.configTablaPeticiones.data.splice(0, this.configTablaPeticiones.data.length);

    initWaitMe('#tblPeticiones');

    this._http.get<IPeticion[]>(`${CONTROL_APP_CONST.API_URL}consultaPeticion`)
        .map((response) => {
          response.forEach((valueRes) => {
            valueRes.comentarios.forEach(this._formatearComentario);
            valueRes.fechaestimada = valueRes.fechaestimada.substring(0, 10);
          });
          return response;
        })
        .subscribe(
            (response) => {
              response.forEach((value) => {
                this.configTablaPeticiones.data.push(value);
              });
            }, (error) => {
              this._errorService.manejaError(error);
            }, () => {
              stopWaitMe('#tblPeticiones');
            }
        )
  }

  enviarMensaje() {
    if (this.detalleNewComentario.comentario != '') {
      this.enviandomensaje = true;

      this._http.post<IPeticionComentario>(`${CONTROL_APP_CONST.API_URL}registroComentPeticion`,
          {
            comentario: this.detalleNewComentario.comentario,
            whrpeticione_id: this.detallePeticion.id
          })
          .map(this._formatearComentario)
          .subscribe(
              (response) => {
                notify(this._translate.instant("COMENTARIO_REGISTRADO_LABEL"), SUCCESS_NOTIFY);
                this.enviandomensaje = false;
                this.detallePeticion.comentarios.unshift(response);
                this.detalleNewComentario.comentario = '';

                setTimeout(() => {
                  animation(BOUNCEIN_ANIMATION, '#mensaje_comentario_' + response.id);
                });
              },
              (error) => {
                this._errorService.manejaError(error);
                this.enviandomensaje = false;
              });

    } else {
      this.detalleNewComentario.hasError = true;
      this.detalleNewComentario.errorText = 'CAMPO_REQUIRED_LABEL';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/control-app/views/peticion/peticion.component.ts